import { Component, Input, OnChanges, OnInit } from '@angular/core';
import { ContentService } from '@blk/cwp-ng-framework';
import { ComponentData, TabData } from '@ddt-web/data-service';
import * as get from 'lodash/get';

@Component({
	selector: 'risk-fi-deep-dive',
	templateUrl: './fi-deep-dive.component.html',
	styleUrls: ['./fi-deep-dive.component.scss']
})
export class FiDeepDiveComponent implements OnChanges, OnInit {

	@Input() public data: ComponentData;

	public asOfDate: string;
	public asOfDateSNP: string;
	public detailsAsOfDate: string;
	public activeSumTab: TabData;
	public totalSumTab: TabData;
	public parentCollapsed: boolean[] = [];
	public decompHeaderTab: TabData;
	public decompositionTabs: TabData[] = [];
	public subTitle: string;
	public title: string;

	constructor(private contentService: ContentService) { }

	public ngOnInit(): void {
		this.subTitle = this.contentService.get('FI_DEEP_DIVE_SUBTITLE', 'FI_DEEP_DIVE_SUBTITLE');
		this.title = this.contentService.get('FI_DEEP_DIVE_TITLE', 'Fixed Income Deep Dive');
	}

	public ngOnChanges(): void {
		if (this.data && this.data.success) {
			const asOfDateTab = this.data.getTabById('risk.asOfDate');
			this.asOfDate = get(asOfDateTab, 'displayConfig.visible') && get(asOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			const asOfDateSNPTab = this.data.getTabById('risk.asOfDate.snp');
			this.asOfDateSNP = get(asOfDateSNPTab, 'displayConfig.visible') && get(asOfDateSNPTab, 'tableData[0].cells[0][0].formattedValue');
			const detailsAsOfDateTab = this.data.getTabById('details.asOfDate');
			this.detailsAsOfDate = get(detailsAsOfDateTab, 'displayConfig.visible') && get(detailsAsOfDateTab, 'tableData[0].cells[0][0].formattedValue');
			this.totalSumTab = this.data.getTabById('fi.total.risk.sum');
			this.activeSumTab = this.data.getTabById('fi.active.risk.sum');
			this.decompHeaderTab = this.data.getTabById('fi.risk.decomposition.header');
			const fiTotalRiskDecompTab = this.data.getTabById('fi.total.risk.decomposition');
			const fiActiveRiskDecompTab = this.data.getTabById('fi.active.risk.decomposition');
			if (fiTotalRiskDecompTab) {
				this.decompositionTabs.push(fiTotalRiskDecompTab);
			}
			if (fiActiveRiskDecompTab) {
				this.decompositionTabs.push(fiActiveRiskDecompTab);
			}
		}
	}

}
